// @mui
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Typography, Card, CardContent, Box, IconButton, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import Iconify from '../../fl-components/Iconify';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  position: 'relative',
  backgroundColor: theme.palette.primary.lighter,
  [theme.breakpoints.up('md')]: {
    height: '100%',
    display: 'flex',
    textAlign: 'left',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
}));

// ----------------------------------------------------------------------

WelcomeBanner.propTypes = {
  action: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.object]),
  description: PropTypes.string,
  img: PropTypes.node,
  title: PropTypes.string,
  onClose: PropTypes.func,
  showCloseBtn: PropTypes.bool
};

export default function WelcomeBanner({
  title,
  description,
  action,
  img,
  onClose,
  showCloseBtn = false,
  ...other
}) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (showCloseBtn) {
      setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress === 100) {
            onClose();
            localStorage.setItem('displayBanner', false);
          }
          return prevProgress + 20;
        });
      }, 1000);
    }
  }, []);

  return (
    <RootStyle {...other}>
      {showCloseBtn && (
        <Box
          sx={{
            position: 'absolute',
            top: '10px',
            left: '10px'
          }}
          onClick={() => onClose()}
        >
          <Box sx={{ position: 'relative' }}>
            <IconButton sx={{ zIndex: 2 }}>
              <Iconify icon="eva:close-fill" />
            </IconButton>
            <CircularProgress
              size={40}
              variant="determinate"
              value={progress}
              sx={{
                // color: green[500],
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 1
              }}
            />
          </Box>
        </Box>
      )}
      <CardContent
        sx={{
          p: { md: 0 },
          pl: { md: 5 },
          color: 'grey.800'
        }}
      >
        <Typography gutterBottom variant="h4" sx={{ whiteSpace: 'pre-line' }}>
          {title}
        </Typography>

        <Typography variant="body2" sx={{ pb: { xs: 3, xl: 5 }, maxWidth: 480, mx: 'auto' }}>
          {description}
        </Typography>

        {action && action}
      </CardContent>

      {img && img}
    </RootStyle>
  );
}
